import { HStack, Text } from '@chakra-ui/react'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTime } from 'luxon'

import type { SeriesUserWithdrawnBannerData } from '@/common/services/seriesPage/types'

import { SeriesWithdrawalSource } from '@/queries/constants'
import * as url from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

export default function SeriesUserWithdrawnBanner({
  series,
}: {
  series: SeriesUserWithdrawnBannerData
}): JSX.Element | null {
  const withdrawal = series.viewer.withdrawal
  if (withdrawal == null) {
    return null
  }

  const withdrawnAtDateTime = DateTime.fromISO(withdrawal.withdrawnAt)
  const withdrawalSource = withdrawal.source
  const withdrawalReason = withdrawal.reason

  if (withdrawalSource === SeriesWithdrawalSource.Tutor) {
    return (
      <HStack
        borderRadius="8px"
        p="24px"
        spacing="16px"
        backgroundColor="red.subtle"
        align="center"
      >
        <FontAwesomeIcon icon={faExclamationCircle} />
        <Text textAlign="left" ml="10px">
          The tutor withdrew you from this series on{' '}
          {withdrawnAtDateTime.toLocaleString(DateTime.DATE_SHORT)} for the following reason:{' '}
          <b>{withdrawalReason}</b>. To appeal to join the series again, please see this{' '}
          <ShwLink href={url.faq.getArticleUrl('removed-from-series')}>FAQ</ShwLink> for more
          information.
        </Text>
      </HStack>
    )
  }
  if (withdrawalSource === SeriesWithdrawalSource.Learner) {
    return (
      <HStack
        borderRadius="8px"
        p="24px"
        spacing="16px"
        backgroundColor="red.subtle"
        align="center"
      >
        <FontAwesomeIcon icon={faExclamationCircle} />
        <Text textAlign="left" ml="10px">
          You withdrew yourself from this series on{' '}
          {withdrawnAtDateTime.toLocaleString(DateTime.DATE_SHORT)}.
        </Text>
      </HStack>
    )
  }
  return null
}
